import React, { useState, useEffect } from "react";
import { TableContainer, TableRowContainer, Paginate } from "./index.styled";
import { useNavigate } from "react-router-dom";
import statusHandler from "utils/processStatusHandler/processStatusHandler";
import moment from "jalali-moment";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import Archives from "services/apis/archivesAPI";
import { toast } from "react-toastify";
import { LuTrash2 } from "react-icons/lu";
import { LuDownload } from "react-icons/lu";
import RemoveItemModal from "../../removeItemModal";
import "./index.css"

const TableSectionMobile = ({ socketStatus }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [tabelData, setTableData] = useState(null);
  const [numberOfPages2, setNumberOfPages2] = useState(0);

  async function getTableData(filters, page=0) {
    const params = {
      count: dataPerPage,
      page: currentPage || page,
    };

    const response = await new Archives().getArchives(params);

    const rows = response.data.data.rows;

    rows?.map?.((item) => {
      const status = statusHandler(item.status);
      item.status_lable = status;
    });

    setTableData(response.data.data);

    let tempNumberOfPages = [...arrOfCurrButtons];

    let dotsInitial = "...";
    let dotsLeft = "... ";
    let dotsRight = " ...";

    const numberOfPages = [
      ...Array(Math.ceil(response.data.data.count / dataPerPage) + 1).keys(),
    ].slice(1);

    setNumberOfPages2(numberOfPages);

    if (numberOfPages.length < 6) {
      tempNumberOfPages = numberOfPages;
    } else if (currentPage >= 1 && currentPage <= 3) {
      tempNumberOfPages = [1, 2, 3, 4, dotsInitial, numberOfPages.length];
    } else if (currentPage === 4) {
      const sliced = numberOfPages.slice(0, 5);
      tempNumberOfPages = [...sliced, dotsInitial, numberOfPages.length];
    } else if (currentPage > 4 && currentPage < numberOfPages.length - 2) {
      // from 5 to 8 -> (10 - 2)
      const sliced1 = numberOfPages.slice(currentPage - 2, currentPage); // sliced1 (5-2, 5) -> [4,5]
      const sliced2 = numberOfPages.slice(currentPage, currentPage + 1); // sliced1 (5, 5+1) -> [6]
      tempNumberOfPages = [
        1,
        dotsLeft,
        ...sliced1,
        ...sliced2,
        dotsRight,
        numberOfPages.length,
      ]; // [1, '...', 4, 5, 6, '...', 10]
    } else if (currentPage > numberOfPages.length - 3) {
      // > 7
      const sliced = numberOfPages.slice(numberOfPages.length - 4); // slice(10-4)
      tempNumberOfPages = [1, dotsLeft, ...sliced];
    } else if (currentPage === dotsInitial) {
      // [1, 2, 3, 4, "...", 10].length = 6 - 3  = 3
      // arrOfCurrButtons[3] = 4 + 1 = 5
      // or
      // [1, 2, 3, 4, 5, "...", 10].length = 7 - 3 = 4
      // [1, 2, 3, 4, 5, "...", 10][4] = 5 + 1 = 6
      setCurrentPage(arrOfCurrButtons[arrOfCurrButtons.length - 3] + 1);
    } else if (currentPage === dotsRight) {
      setCurrentPage(arrOfCurrButtons[3] + 2);
    } else if (currentPage === dotsLeft) {
      setCurrentPage(arrOfCurrButtons[3] - 2);
    }
    setArrOfCurrButtons(tempNumberOfPages);
    if (page) {
      setCurrentPage(page);
    } else {
      setCurrentPage(currentPage);
    }
  }
  useEffect(() => {
    if (tabelData && currentPage === 1) {
      const newn = [];
      tabelData?.rows?.map?.((item, index) => {
        const obj = { ...item };
        if (index === 0) {
          obj.status = socketStatus;
          const status = statusHandler(socketStatus);
          obj.status_lable = status;
        }
        newn.push(obj);
      });
      setTableData((prev) => ({ ...prev, rows: newn }));
    }
  }, [socketStatus]);

  useEffect(() => {
    getTableData(null, null);
  }, [currentPage, dataPerPage, socketStatus]);

  const [arrOfCurrButtons, setArrOfCurrButtons] = useState([]);

  return (
    <>
      {tabelData?.length === 0 && (
        <div className="mt-4 text-center font-semibold">
          دیتایی برای نمایش وجود ندارد
        </div>
      )}

      {tabelData &&
        tabelData?.rows?.map?.((row, index) => {
          const rowNumber =
            currentPage !== 1 ? (currentPage - 1) * 10 + index + 1 : index + 1;

          return <TableRow row={row} rowNumber={rowNumber} key={index} callback = {()=>getTableData(null, tabelData.rows.length< 2 ? currentPage-1 : currentPage)} />;
        })}
      {tabelData && (
        <Paginate>
          <ul>
            {/* <PageCounter
            active={numberOfPages2.length !== currentPage ? true : false}
            dataPerPageCounter={(num) => setDataPerPage(num)}
          /> */}
            <li>
              <a
                href="#"
                className={`${currentPage === 1 ? "disabled" : ""}`}
                onClick={() =>
                  setCurrentPage((prev) => (prev <= 1 ? prev : prev - 1))
                }
              >
                <MdKeyboardArrowRight />
              </a>
            </li>
            {arrOfCurrButtons?.map?.((item, index) => {
              return (
                <li key={index}>
                  <a
                    href="#"
                    key={index}
                    className={`${currentPage === item ? "active" : ""}`}
                    onClick={() => setCurrentPage(item)}
                  >
                    {item}
                  </a>
                </li>
              );
            })}
            <li>
              <a
                href="#"
                className={`${
                  currentPage === numberOfPages2.length ? "disabled" : ""
                }`}
                onClick={() =>
                  setCurrentPage((prev) =>
                    prev >= numberOfPages2.length ? prev : prev + 1
                  )
                }
              >
                <MdKeyboardArrowLeft />
              </a>
            </li>
          </ul>
        </Paginate>
      )}
    </>
  );
};

function TableRow({ row, callback = ()=>{} }) {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
  }
  const openModal = (e) => {
    e.stopPropagation();
    setShowModal(true);
  }

  const formateDate = () => {
    const onlyDay =
      row.createdAt.substring(0, row.createdAt.lastIndexOf("T")) ||
      row.createdAt;
    const ready = onlyDay.replace(/[-]/g, "/");
    const mo = moment(ready, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD");
    return moment(ready, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD");
  };

  function removeExtension(filename) {
    return filename.substring(0, filename.lastIndexOf(".")) || filename;
  }

  function rowOnClick() {
    row.status === "success" &&
      navigate(`/convert-text-to-speech/edit/${row.id}`);
  }

  async function downloadOnClick(e, status) {
    e.stopPropagation();
    e.preventDefault();
    if(status!=='success'){ return }

    if (!row.result.aiResult) {
      toast.info("لینک دانلود موجود نیست لطفا صفحه را مجددا بارگزاری نمایید ");

      return;
    }
    await new Archives()
      .getDownloadTextArchives(row.result.aiResult)
      .then((r) => {
        // const div = e.target;

        const a = document.createElement("a");

        const data = r.data;

        const file = new Blob([data], { type: "audio/mpeg" });

        a.href = window.URL.createObjectURL(file);

        a.download = `${row.title}.mp3`;

        // div.appendChild(a);

        a.click();

        a.remove();
      });
  }

  const removeItemHandler = async (id)=>{
    await new Archives()
    .removeItem(id)
    .then((r) => {
      const response = r.data;
      if(response.status==='success'){
        toast.success('عملیات با موفقیت انجام شد.');
        callback()
      }
      closeModal();
    })
    .catch((err) => {
      if (err?.response?.data?.data) {
        toast.warning(err?.response?.data?.data);
      }
    });
  }

  return (
    <TableContainer
      onClick={rowOnClick}
      className={row.status !== "success" ? "table-row-card disable" : "table-row-card"}
    >
      {
        row.status!=='success' && <div className="row-overlay" />
      }
      <TableRowContainer>
        <div className="rowTitle">{removeExtension(`${row.title}`)}</div>
        <div className="textCount">{row.meta_data.textCount}</div>
      </TableRowContainer>
      <TableRowContainer className="status">
        <div>وضعیت</div>
        <div>{row.status_lable}</div>
      </TableRowContainer>
      <TableRowContainer className="time">
        <div>زمان انجام</div>
        <div>{formateDate()}</div>
      </TableRowContainer>
      <TableRowContainer className="cost">
        <div>هزینه</div>
        <div>{Math.abs(`${row.Transaction.amount}`)}</div>
      </TableRowContainer>
      <TableRowContainer>
        <button onClick={(e) => downloadOnClick(e, row.status)} className="download-button">
          <LuDownload/>
          <span className="button-value">دانلود</span>
        </button>
        <button onClick={openModal} className="delete-button">
          <LuTrash2/>
          <span className="button-value">حذف</span>
        </button>
      </TableRowContainer>

      <RemoveItemModal show={showModal} onClose={closeModal}>
        <h2 style={{marginBottom: '20px', color: '#121212'}}>آیا از حذف این فایل اطمینان دارید؟</h2>
        <div>
          <button onClick={()=>removeItemHandler(row.id)} className="accept-button-modal">بله</button>
          <button onClick={closeModal} className="cancel-button-modal">خیر</button>
        </div>
      </RemoveItemModal>
    </TableContainer>
  );
}

export default TableSectionMobile;
